import generateActions from 'utils/actions';

export const GET_MAILBOX = generateActions('mailbox/GET_MAILBOX');
export const GET_SEARCH_USERS = generateActions('mailbox/GET_SEARCH_USERS');
export const GET_USER = generateActions('mailbox/GET_USER');
export const GET_THREAD = generateActions('mailbox/GET_THREAD');
export const POST_MESSAGE = generateActions('mailbox/POST_MESSAGE');
export const PUT_MESSAGE = generateActions('mailbox/PUT_MESSAGE');
export const SELECT_USER = 'mailbox/SELECT_USER';
export const SET_VALUE = 'mailbox/SET_VALUE';

/**
 * Load a user to get basic information
 * @param {Number} userId 
 */
export function loadUser(userId) {
  return {
    types: GET_USER,
    promise: {
      url: `/users/${userId}`,
    },
  };
}

/**
 * Search users by name
 * @param {String} query 
 */
export function searchUser(query) {
  return {
    types: GET_SEARCH_USERS,
    promise: {
      url: `/users?search=${query}`,
    },
    data: {
      query,
    },
  };
}

/**
 * Selects the user to send
 * @param {User} user 
 */
export function selectDestinationUser(user) {
  return {
    type: SELECT_USER,
    payload: {
      user,
    }
  };
}

/**
 * Sets the value for subject and content fields
 * @param {String} name 
 * @param {String} value 
 */
export function setFieldValue(name, value) {
  return {
    type: SET_VALUE,
    payload: {
      name,
      value,
    },
  };
}

/**
 * Sends a new message to the given user
 * @param {String} subject 
 * @param {String} content 
 * @param {User} to 
 */
export function postThread(subject, content, to) {
  return {
    types: POST_MESSAGE,
    promise: {
      url: '/mailbox/messages',
      method: 'POST',
      data: {
        title: subject,
        content,
        recipients: [{ id: to.id }]
      }
    },
  };
}

/**
 * Adds a new message to a thread
 * @param {Number} id The thread ID to post this message 
 * @param {String} content 
 */
export function putThread(id, content, author) {
  return {
    types: PUT_MESSAGE,
    promise: {
      url: `/mailbox/messages/${id}`,
      method: 'PUT',
      data: {
        id,
        content,
      },
    },
    data: {
      content,
      author,
      time: {
        date: Date.now(),
      },
    }
  };
}

/**
 * Load the list of messages
 * @param {String} list 
 */
export function loadSent(list) {
  const url = list === 'sent'
    ? '/mailbox/messages/sent'
    : '/mailbox/messages/received';

  return {
    types: GET_MAILBOX,
    promise: {
      url,
    },
    data: {
      list: list === 'sent' ? 'sent' : 'inbox',
    },
  };
}

/**
 * Loads a thread
 * @param {Number} threadId 
 */
export function loadThread(threadId) {
  return {
    types: GET_THREAD,
    promise: {
      url: `/mailbox/messages/${threadId}`
    },
  };
}
